import { useState, useMemo, useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { DropDown } from 'Common/Supplyvue-ui'
import {
  EditWeekRangeProps,
  WeekDropdownType,
} from './StockProjectionException.types'

export const EditWeekRange = ({
  weeks,
  config,
  handleWeekRangeChange,
  loading,
}: EditWeekRangeProps) => {
  const [startWeek, setStartWeek] = useState<number>(config.start as number)
  const [endWeek, setEndWeek] = useState<number>(config.end as number)
  useEffect(() => {
    setStartWeek(config.start as number)
    setEndWeek(config.end as number)
  }, [config])

  const endWeekArray = useMemo(() => {
    if (startWeek) {
      const sw = startWeek as number
      return weeks.filter(
        (weekDetails: WeekDropdownType) =>
          weekDetails.value && (weekDetails.value as number) > sw
      )
    }
    return []
  }, [startWeek])

  const handleStartingWeekChange = (
    event: React.ChangeEvent<{ name?: string; value: number }>
  ) => {
    const { value } = event.target
    const newStartWeek = value as number
    if (endWeek > newStartWeek) {
      setStartWeek(newStartWeek)
      handleWeekRangeChange({ start: value as number, end: endWeek as number })
    }
  }

  const handleEndingWeekChange = (
    event: React.ChangeEvent<{ name?: string; value: number }>
  ) => {
    const { value } = event.target
    setEndWeek(value)
    handleWeekRangeChange({ start: startWeek as number, end: value })
  }

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <Box marginRight="5px">
        <Typography>Week range</Typography>
      </Box>
      <Box display="flex" justifyContent="space-between">
        <Box width="200px">
          <DropDown
            //fullWidth
            sx={{
              height: '40px',
            }}
            label="startingWeek"
            name="startingWeek"
            menuItems={weeks}
            value={startWeek}
            onChange={handleStartingWeekChange}
            placeholder="Select week"
            disabled={loading}
          />
        </Box>
        <Box width="200px">
          <DropDown
            //fullWidth
            sx={{
              height: '40px',
            }}
            label="endingWeek"
            name="endingWeek"
            menuItems={endWeekArray}
            value={endWeek}
            onChange={handleEndingWeekChange}
            placeholder="Select week"
            disabled={loading}
          />
        </Box>
      </Box>
    </Box>
  )
}
